import React from 'react';
import './Accordion.css';

interface Props {
  children?: React.ReactNode;
}

const AccordionDetail: React.FC<Props> = ({ children }): JSX.Element => {
  return <div className="accordion-detail">{children}</div>;
};

export default AccordionDetail;
